// extracted by mini-css-extract-plugin
export var contrastLow = "_3u-1";
export var externalLink = "_3u-2";
export var externalLinkIcon = "_3u-3";
export var link = "_3u-0";
export var linkLabel = "_3u-4";